import { msalInstance } from "@/auth";
import { loginRequest } from "@/authconfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Api } from "./generated/Api";
import { toast } from "sonner";
import { ENV } from "@/env";

let isRedirectingToLogin = false;

const redirectToLogin = () => {
  if (isRedirectingToLogin) return;
  isRedirectingToLogin = true;

  msalInstance.clearCache();
  window.location.replace(`/login?redirect=${window.location.pathname}`);
};

const authenticatedFetch: typeof fetch = async (...args) => {
  const response = await fetch(...args);
  if (response.status === 401) redirectToLogin();
  return response;
};

export const apiClient = new Api({
  baseUrl: ENV.apiUrl,
  customFetch: authenticatedFetch,
  baseApiParams: {
    secure: true,
  },
  securityWorker: async () => {
    const response = await msalInstance
      .acquireTokenSilent(loginRequest)
      .catch(async (error) => {
        if (error instanceof InteractionRequiredAuthError) {
          redirectToLogin();
          return;
        }
        redirectToLogin();
        toast.error("Your session has expired. Please log in again.");
      });

    if (!response) throw new Error("Could not acquire token");

    return {
      headers: {
        Authorization: `Bearer ${response.accessToken}`,
      },
    };
  },
});
